import { Component, OnInit, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { Validators, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ConstantService, Scout } from '../../../shared';
import { AuthenticationService } from '../../../core/authentication/authentication.service';
import { environment } from '../../../../environments/environment';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-account-login',
    templateUrl: './account-login.component.html',
    styleUrls: ['./account-login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountLoginComponent implements OnInit {
  @HostBinding('class.component-wrapper') defaultClass: boolean;
  version: string = environment.version;
  error: string;
  loginForm: UntypedFormGroup;
  returnUrl: string;
  isLoading = false;
  submitted = false;
  authenticated: boolean;
  scouts: Scout[];
  userName: string;
  currentIp: string;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private _authService: AuthenticationService,
    private _constService: ConstantService
  ) {
    if (this._constService.user) {
      this.userName = this._constService.user.userName;
      this.currentIp = this._constService.ipAddress;
    }
    // The template binds [formGroup]="loginForm", so it must exist even when a signed-in
    // user is only passing through on the way to /issues.
    this.createForm();
    if (this._authService.isAuthenticated) {
      // Wait for the user type, then land on Customers if this account can open the
      // menu pages, otherwise on the Support Landing page.
      this._constService.accessResolved$.pipe(take(1)).subscribe((canOpenPages) => {
        this.router.navigate([canOpenPages ? 'customers' : 'issues']);
      });
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }

  ngOnInit() {
    this.defaultClass = true;
  }

  azureLogin() {
    this._authService.login();
  }

  login() {
    console.log('form control here')
  }

  sendNotification() {
    console.log('button clicked for notification');
  }

  logout() {
    localStorage.setItem("id_token", "");
    localStorage.clear();
    this._authService.logout();
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: [
        '',
        Validators.required
      ],
      password: [
        '',
        Validators.required,
        Validators.minLength(5)
      ],
      remember: true
    });
  }
}
